import PropTypes from 'prop-types'
import React from 'react'
import Base from '../../containers/BaseContainer'
// import { I18n } from 'react-redux-i18n'

import classNames from 'classnames'
// import globalStyles from '../../styles/styles.module.scss'
import styles from './ReleaseNote.module.scss'
import './ReleaseNote.module.scss'
import axios from 'axios'
import moment from 'moment'
moment.locale('fr')
// import 'moment/locales/fr'
// import 'moment/locales/en'
// import Constants from '../../services/constants/Constants'
// import { hasAuthorization } from '../../ContentUtils'

// export const viewers = ['ios', 'android']
// export const profileMenu = ['account', 'team', 'myApps', 'admin', 'logout']

class ReleaseNote extends Base {

  constructor(props) {
    super(props)
    this.state = {
      show: false,
      willClose: false,
      // list: null,
      // selectedNote: null,

      list: null,
      selectedNote: null,
      selectedContent: null,
      userShowPreference: null,
    }
  }

  componentDidMount() {
    let userShowPreference = localStorage.getItem('sw_release_note_hide')
    if (this.props.forceShow) {
      this.setState({ show: true, userShowPreference })
      if (!this.props.list || !this.props.selectedNote) {
        this.init()
      } else {
        this.fetchNoteContent(this.props.selectedNote)
        this.setState({ list: this.props.list, selectedNote: this.props.selectedNote })
      }
    }
  }
  init = () => {
    axios.get('https://release-note.swizi.io/list').then(res => {
      let list = res.data
      if (list.length) {
        list = list.sort((a, b) => {
          if (a.timestamp > b.timestamp) return -1
          else return 1
        })
        let selectedNote = list[0]
        localStorage.setItem('sw_release_note_last_seen', selectedNote.timestamp)
        this.fetchNoteContent(selectedNote.id)
        this.setState({ list: res.data, selectedNote: selectedNote.id })
      }
    }).catch(err => console.log(err))
  }

  fetchNoteContent = (id) => {
    axios.get(`https://release-note.swizi.io/releaseNote/${id}`).then(res => {
      let selectedContent = res.data
      let parser = new DOMParser()
      let doc = parser.parseFromString(selectedContent, 'text/html')
      // console.log(doc.body.innerHTML)
      let contentContainer = document.getElementById('bodyContainer')
      if (contentContainer) {
        contentContainer.innerHTML = doc.body.innerHTML
        this.setState({ selectedContent: doc.body })
      }
    })
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.forceShow && !this.state.show) {
      this.setState({ show: true, willClose: false })
      this.init()
    }
  }
  handleClickClose = () => {
    this.setState({ willClose: true }, () => setTimeout(() => {
      this.setState({ show: false })
      this.props.onClose()
    }, 250))
  }
  handleChangeSelectedNote = id => {
    this.setState({ selectedNote: id })
    this.fetchNoteContent(id)
  }
  handleChangeCheck = event => {
    let checked = event.target.checked
    if (checked) {
      localStorage.setItem('sw_release_note_hide', true)
      this.setState({ userShowPreference: true })
    } else {
      localStorage.removeItem('sw_release_note_hide')
      this.setState({ userShowPreference: false })
    }
  }
  getFormatedDay = timestamp => {
    // console.log(timestamp)
    // console.log(new Date(timestamp))
    let date = new Date(timestamp)
    return `Notes du ${moment(date).format('L')}`
  }
  render() {
    return this.state.show ? (
      <div className={styles.releaseNoteContainer}>
        <div className={this.state.willClose
          ? classNames(styles.releaseNoteWrapper, styles.exit)
          : classNames(styles.releaseNoteWrapper)}
        >
          <div className={styles.releaseNoteHeader}>
            <div className={styles.releaseNote} onClick={this.props.handleShowReleaseNote}>

            </div>
            <div style={{ flex: 2, fontSize: '20px' }}>
              Notes de mise à jour
              </div>
            <div className={styles.closeButton} onClick={() => this.handleClickClose()}></div>
          </div>
          <div className={styles.releaseNoteContent}>
            <div className={styles.releaseNoteList}>
              {this.state.list && this.state.list.map(el => {
                return (
                  <div key={el.id} className={this.state.selectedNote === el.id
                    ? classNames(styles.releaseNoteListRow, styles.releaseNoteListRowSelected)
                    : classNames(styles.releaseNoteListRow)}
                    onClick={() => this.handleChangeSelectedNote(el.id)}
                  >{this.getFormatedDay(el.timestamp)}</div>
                )
              })}
            </div>
            <div id='bodyContainer' className={styles.releaseNoteSelected}>
            </div>
          </div>
          <div className={styles.checkBoxShow}>
            <input type='checkbox' checked={this.state.userShowPreference}
              onChange={this.handleChangeCheck} />
            <div className={styles.checkBoxShowText}>Ne plus m'informer automatiquement</div>
          </div>
        </div>

      </div>
    ) : <div></div>
  }
}

ReleaseNote.propTypes = {
  forceShow: PropTypes.bool,
}

export default ReleaseNote
